/** Money is integer cents everywhere; this is the one way it becomes text: `$1,284.62`, `−$412.00`. */
const fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

export function formatMoney(cents: number): string {
  const text = fmt.format(Math.abs(cents) / 100);
  return cents < 0 ? `−${text}` : text;
}

/** `1284.62` typed by a person → 128462. Refuses anything that is not money. */
export function parseMoney(text: string): number | null {
  const clean = text.replace(/[$,\s]/g, '');
  if (!/^-?\d+(\.\d{1,2})?$/.test(clean)) return null;
  const negative = clean.startsWith('-');
  const [whole, frac = ''] = clean.replace('-', '').split('.');
  const cents = Number(whole) * 100 + Number((frac + '00').slice(0, 2));
  return negative ? -cents : cents;
}

/**
 * A count, as a person reads it: `1,340`. The one way a number of things becomes text.
 *
 * `toLocaleString` is refused everywhere (ADR 0006's rule bans the property outright, so nobody
 * renders a local time with it), and a count still wants its separators — so it gets a
 * formatter of its own rather than an exception.
 */
const counted = new Intl.NumberFormat('en-US');
export function formatCount(n: number): string {
  return counted.format(n);
}
